import { MouseEventHandler, ReactNode, RefObject } from 'react'
import classnames from 'classnames'
import { IconButton } from '../../../components/common'

type OverlayDrawerProps = {
    name: string
    title: string
    content: ReactNode
    isOpen: boolean
    onClose?: MouseEventHandler
    containerRef?: RefObject<HTMLDivElement>
}

export const OverlayDrawer: React.FC<OverlayDrawerProps> = (props) => {
    const { content, title, isOpen, name, onClose, containerRef } = props

    const className = classnames(
        'absolute inset-0 z-20',
        'overflow-hidden',
        'pointer-events-none'
    )

    const innerClassName = classnames(
        'group',
        'absolute top-0 right-0 bottom-0',
        'w-[400px]',
        'bg-white border-l border-neutral-200 shadow-xl',
        'transition-all ease-out duration duration-300',
        'grid grid-rows-[auto_1fr]',
        'pointer-events-auto',
        {
            'is-open': isOpen,
            'translate-x-full shadow-(color:transparent)': !isOpen,
        }
    )

    return (
        <div data-testid={name} className={className} ref={containerRef}>
            <div className={innerClassName}>
                <div className="ga-6 flex justify-between border-b border-neutral-200 px-6 py-4">
                    <div className="text-heading-6">{title}</div>
                    {onClose && (
                        <IconButton
                            name={`${name}-close-button`}
                            icon={'close'}
                            size={'medium'}
                            variant="ghostTertiary"
                            onClick={onClose}
                        />
                    )}
                </div>
                <div className="overflow-auto p-6">{content}</div>
            </div>
        </div>
    )
}
